import { NsjAuthInstance } from '@core/authentication/nsj-autenticacao';
import { NsjRoutingInstance } from '@core/routing/nsj-rotas';
import { ServerError } from '@core/services/server-error';
import { removerFragmentoDaUrlNavegador } from '@utils/utils';
import { painelAdministrativoPage } from './painel-administrativo.page';

const ROTA = 'painel-administrativo';

/**
 * Entrada do painel administrativo. Autentica no Keycloak e carrega o fosrouting, mas pula a
 * carga do usuário e a escolha de tenant/grupo/estabelecimento da aplicação: o painel não é por tenant.
 */
export class PainelAdministrativoRouter {

    static isRota(pathname: string = window.location.pathname): boolean {
        return pathname.replace(/^\/+|\/+$/g, '') === ROTA;
    }

    static async iniciar(): Promise<void> {
        try {
            await NsjAuthInstance.iniciarAuth();
            removerFragmentoDaUrlNavegador();
            await NsjRoutingInstance.carregarRotas();
            await painelAdministrativoPage.mount();
        } catch (error) {
            console.error(error);
            ServerError.showErrorPage({
                mensagemPrincipal: 'Não foi possível abrir o painel administrativo.',
                mensagemComplementar: 'Verifique o login e tente novamente.'
            });
        }
    }
}
